export const FEATURES = {
  ITEM_CATALOGING: 'Item-Cataloging',
  CUSTOM_FORMS: 'Item-Cataloging',
  SETTINGS: 'Item-Cataloging',
  MULTI_LANGUAGE: 'Item-Cataloging',
  GLOBAL_SEARCH: 'Item-Cataloging',
};

function checkEnabledFeatures(currentUser, feature) {
  if (
    currentUser &&
    currentUser.enabledFeatures &&
    currentUser.enabledFeatures.includes(feature)
  ) {
    return true;
  }
  return false;
}

export default checkEnabledFeatures;
